import React, { useState } from "react";
import { Box, Paper, Stack, Typography, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { theme } from "../../../../Theme";

export function SectionHeader({ icon, title, subtitle, compact }) {
  return (
    <Stack
      direction="row"
      spacing={1.25}
      alignItems="flex-start"
      mb={compact ? 0 : 2.5}
      sx={{ flex: 1, minWidth: 0 }}
    >
      <Box
        sx={{
          mt: 0.2,
          flexShrink: 0,
          width: 34,
          height: 34,
          borderRadius: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: `${theme.palette.primary.main}12`,
          color: theme.palette.primary.main,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography
          variant="subtitle1"
          fontWeight={700}
          color={theme.palette.primary.main}
          sx={{ letterSpacing: "-0.01em", lineHeight: 1.3 }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}

export function CollapsibleSection({
  icon,
  title,
  subtitle,
  children,
  filterBar,
  sx,
  defaultExpanded = true,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2.25, sm: 3 },
        borderRadius: 2,
        border: "1px solid #E8ECF0",
        boxShadow: "0 1px 3px rgba(15,23,42,0.04)",
        ...sx,
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={1}
        onClick={() => setExpanded((v) => !v)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setExpanded((v) => !v);
          }
        }}
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
        sx={{
          cursor: "pointer",
          userSelect: "none",
          mb: expanded ? 2.5 : 0,
          outline: "none",
          borderRadius: 1,
          "&:focus-visible": {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}40`,
          },
        }}
      >
        <SectionHeader icon={icon} title={title} subtitle={subtitle} compact />
        {expanded ? (
          <ExpandLessIcon
            sx={{ color: "text.secondary", fontSize: 28, mt: 0.15, flexShrink: 0 }}
            aria-hidden
          />
        ) : (
          <ExpandMoreIcon
            sx={{ color: "text.secondary", fontSize: 28, mt: 0.15, flexShrink: 0 }}
            aria-hidden
          />
        )}
      </Stack>
      <Collapse in={expanded} timeout="auto">
        <Box>
          {filterBar && <Box sx={{ mb: 2.5 }}>{filterBar}</Box>}
          {children}
        </Box>
      </Collapse>
    </Paper>
  );
}
